//
/* This is for 49.45 migrated to 10.21.76.118 */

module.exports = {
  endpoints: {
    category: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/products/category'
    },
    categoryV4: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v4/rilfnl/products/category'
    },
    topSearches: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/products'
    },
    products: {
      href: 'http://10.21.77.213:8080/aggregator/pdp'
    },
    checkProductServiceability:{
      href: 'http://10.21.77.213:8080/aggregator/pdp/serviceability'
    },
    capsulecp: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/capsule'
    },
    capsulenewin: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/capsule/capsuleNewIn'
    },
    curatedPage: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/category'
    },
    recommend: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/recommend'
    },
    recommendation: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/recommendation/v1/pairing/products'
    },
    ensamble: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/ensamble'
    },
    recentlyViewed: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/recentlyViewed'
    },
    productdeliverycheck: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/productdeliverycheck'
    },
    capsules: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/capsule/productCapsule'
    },
    search: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/products/search'
    },
    searchV4: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v4/rilfnl/products/search'
    },
    newdesignhomepage: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/newdesignhomepage'
    },
    landingPageRuntime: {
      href: 'http://uat.cms.ajio.ril.com/storefront/cms/page'
    },
    cmsComponent: {
      href: 'http://uat.cms.ajio.ril.com/storefront/cms/component'
    },
    landingPageRuntimePreview: {
      href: 'http://uat.cms.ajio.ril.com/cms-editor/v1/page/preview'
    },
    landingPageRuntimeArchive: {
      href: 'http://uat.cms.ajio.ril.com/cms-editor/v1/page/archive'
    },
    newcategoryselection: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/newcategoryselection'
    },
    searchsuggestions: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/products/suggestions'
    },
    navigationdesktop: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/navigation/all'
    },
    runtimeNavigationDesktop: {
      href: 'http://uat.cms.ajio.ril.com/storefront/cms/navigation'
    },
    runtimeNavigationDesktopPreview: {
      href: 'http://uat.cms.ajio.ril.com/cms-editor/v1/navigation/preview'
    },
    runtimeLocale: {
      href: 'http://uat.cms.ajio.ril.com/storefront/cms/locale'
    },
    navigationmobile: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/navigation/navnodes'
    },
    myaccount: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/navigation'
    },
    footer: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/footer/navlinks'
    },
    leaderBoard: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/topshopper'
    },
    accountCheck: {
      href: 'https://identity-uat.ajio.ril.com/rilfnlwebservices/v2/rilfnl/accountCheck'
    },
    loginToken: {
      href: 'https://identity-uat.ajio.ril.com/rilfnlwebservices/oauth/token'
    },
    generateLoginOTP: {
      href: 'https://identity-uat.ajio.ril.com/rilfnlwebservices/v2/rilfnl/login/sendOTP'
    },
    signUpAndSocial: {
      href: 'https://identity-uat.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    signUpKiosk: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/registerKiosk'
    },
    selfcarefaq: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/selfcare/footer'
    },
    selfcareFaqSearch: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/searchService/FAQ/search'
    },
    selfcareInitChat: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/selfcare/initiateChat'
    },
    signInSocial: {
      href: 'https://identity-uat.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    setNewPassword: {
      href:
        'https://identity-uat.ajio.ril.com/rilfnlwebservices/v2/rilfnl/forgottenpasswordtokens/set/password'
    },
    selfcareOrderDetails: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    getProfile: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/users/current'
    },
    npsFormQuestionsData: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/survey'
    },
    npsFormAnswerSubmit: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/survey/submitsurvey'
    },
    getStoreList: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/SISStore'
    },
    getStoreListCms: {
      href: 'http://uat.cms.ajio.ril.com/storefront/cms/stores'
    },
    getStoreListCmsRevampedPreview: {
      href: 'http://uat.cms.ajio.ril.com/cms-editor/store/preview?platform=MOBILE&tenantId=AJIO'
    },
    sizeGuide: {
      href: 'http://10.21.79.36:8080/sizechart/getBrickBrandVendorStyleSizeChart'
    },
    productLevelSizeGuide: {
      href: 'http://10.21.79.36:8080/sizechart/productLevelSizeGuide'
    },
    recommendUserSize: {
      href: 'http://10.21.79.36:8080/sizechart/recommendUserSize'
    },
    fetchUserSizeGuide: {
      href: 'http://10.21.79.36:8080/sizechart/fetchUserSizeGuide'
    },
    kioskIPWhitelist: {
      href: 'https://assets-uat.ajio.ril.com/snoop/kioskIPWhitelist.json'
    },
    roadblock: {
      href:
        'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/roadblockbannercmp?uiel=Mobile&format=json'
    },
    appticker: {
      href:
        'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/appstickybannercmp?uiel=Mobile&format=json'
    },
    submitAssistantId: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/submitEmpId'
    },
    verifyOTP: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/login/verifyOTP'
    },
    generateCreditUsageOTP: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/kiosk/sendOTP'
    },
    kioskEntryPage: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/kiosklandingpage'
    },
    sessionClear: {
      href: 'https://identity-uat.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users'
    },
    checkDeliveryDetails: {
      href: 'http://10.21.77.213:8080/aggregator/edd/checkDeliveryDetails'
    },
    checkServiceableCart: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    mobileBottomNavList: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/cms/component'
    },
    uploadReturnProductImages: {
      href:
        'https://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/users/USER_EMAIL_ID/returns/uploadReturnimage'
    },
    flashSaleApiUrl: {
      href: 'http://flashsale-uat.ajio.ril.com/flashsale'
    },
    flashSaleUrl: {
      href: 'https://flashsale-uat.ajio.ril.com/flashsale'
    },
    fetchIfscCodeDetails: {
      href: 'https://payment-uat.services.ajio.com/payment-engine/api/v1/bank/details'
    },
    luxeBrandsList: {
      href:
        'http://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/catalogs/rilfnlProductCatalog/Online/categories/luxebrands'
    },
    bankOffers: {
      href: 'http://qa.services.ajio.com/rilfnlwebservices/v2/rilfnl/allActiveBankOffer'
    },
    uaasLoginToken: {
      href: 'http://uaas-uat.ajio.com/uaas/jwt/token/client'
    },
    uaasAccountCheck: {
      href: 'http://uaas-uat.ajio.com/uaas/accountCheck'
    },
    uaasGetProfile: {
      href: 'http://uaas-uat.ajio.com/uaas/users/current'
    },
    uaasGenerateLoginOtp: {
      href: 'http://uaas-uat.ajio.com/uaas/login/sendOTP'
    },
    uassGenerateVerifyOtp: {
      href: 'http://uaas-uat.ajio.com/uaas/update/sendOTP'
    },
    uassVerifyMobileNumberOtp: {
      href: 'http://uaas-uat.ajio.com/uaas/update'
    },
    uassFetchEmailByUrl: {
      href: 'http://uaas-uat.ajio.com/uaas/fetchEmailByURL'
    },
    uaasSessionClear: {
      href: 'http://uaas-uat.ajio.com/uaas/users'
    },
    uaasSignupAndSocial: {
      href: 'http://uaas-uat.ajio.com/uaas/registerUser'
    },
    uaasSignupAndSocialNewDesign: {
      href: 'http://uaas-uat.ajio.com/uaas/newAppRegisterUser'
    },
    uaasSignInSocial: {
      href: 'http://uaas-uat.ajio.com/uaas/login/socialLogin'
    },
    uaasUpdateUserDetails: {
      href: 'http://uaas-uat.ajio.com/uaas/users/updateUser/details'
    },
    uaasRefreshToken: {
      href: 'http://uaas-uat.ajio.com/uaas/jwt/token/refresh'
    },
    uaasLogin: {
      href: 'http://uaas-uat.ajio.com/uaas/login'
    },
    uaasMyJioLogin: {
      href: 'http://uaas-uat.ajio.com/uaas/myjio/login'
    },
    uaasGetUserInfo: {
      href: 'http://uaas-uat.ajio.com/uaas/users/getUserProfileByEmailId'
    },
    uaasUserInfoOtp: {
      href: 'http://uaas-uat.ajio.com/uaas/users/editaddress'
    },
    uaasEmailUpdateOtp: {
      href: 'http://uaas-uat.ajio.com/uaas/update/sendOTP'
    },
    uaasEmailVerifyOtp: {
      href: 'http://uaas-uat.ajio.com/uaas/update/verifyOTP'
    },
    uaasMobileUpdate: {
      href: 'http://uaas-uat.ajio.com/uaas/users/update/mobileNumber/request'
    },
    uaasMobileUpdateCancel: {
      href: 'http://uaas-uat.ajio.com/uaas/users/updateMobileNumber/cancel'
    },
    fetchBankTransferStatus: {
      href:
        'https://payment-uat.services.ajio.com/payment-engine/api/v1/refund/bank-transfer-status'
    },
    uaasVerfiyEmailInfo: {
      href: 'http://uaas-uat.ajio.com/uaas/users/verifyEmail'
    },
    jioBannerAdsListing: {
      href: 'https://mercury-stg.jio.com/delivery/mapi.php'
    },
    fleekExploreBrands: {
      href: 'http://qa.services.ajio.com/rilfnlwebservices/v1/rilfnl/brands'
    },
    fleekExplore: {
      href: 'http://qa.services.ajio.com/common-aggregator/users/uuid/brands/explore'
    },
    fleekFeed: {
      href: 'http://10.166.181.81:30990/feed-engine/v2/feed'
    },
    fleekFeedPreview: {
      href: 'http://10.166.181.81:30990/feed-engine/v1/feed/preview'
    },
    fleekSesPostSeen: {
      href: 'https://qa.services.ajio.com/ses/v1/content/seen'
    },
    fleekBrandFollow: {
      href: 'https://qa.services.ajio.com/ses/v1/brand/action/'
    },
    fleekSesPostLike: {
      href: 'https://qa.services.ajio.com/ses/v1/content/action/'
    },
    fleekPostShare: {
      href: 'https://qa.services.ajio.com/ses/v1/content/share/'
    },
    fleekBrandPage: {
      href: 'http://qa.services.ajio.com/common-aggregator/users/uuid/brand'
    },
    fleekIndividualPost: {
      href: 'http://qa.services.ajio.com/feed-engine/v1/getPost'
    },
    fleekStories: {
      href: 'http://10.166.181.81:30990/feed-engine/v1/getstories'
    },
    generateCaptchaMobileRestore: {
      href: 'http://uaas-uat.ajio.com/uaas/generate/captcha'
    },
    generateEmailForRestoreMobile: {
      href: 'http://uaas-uat.ajio.com/uaas/mobileUpdate/generateEmail'
    },
    affiseGetConversions: {
      href: 'https://api-ajios.affise.com/3.0/stats/conversions'
    },
    affiseEditConversions: {
      href: 'https://api-ajios.affise.com/3.0/admin/conversion/edit'
    },
    affisePostback: {
      href: 'https://offers-ajios.affise.com/postback'
    },
    customerTypeUAAS: {
      href: 'http://uaas-uat.ajio.com/uaas/v2/rilfnl/users/CUSTOMER_ID/customertype'
    },
    customerTypeUAASV4: {
      href: 'http://uaas-uat.ajio.com/uaas/v4/rilfnl/users/customertype?service='
    },
    myAccountCMS: {
      href: 'http://uat.cms.ajio.ril.com/storefront/cms/page/static?content=navigation&name=myaccount'
    },
    uaasVerifyPan: {
      href: 'http://uaas-uat.ajio.com/uaas/users/verifyTaxPayerId'
    },
    accountDelete: {
      href: 'https://qa.services.ajio.com/uaas/users/CUSTOMER_ID/deleteAccount'
    },
    rushAvailabilityCall: {
      href: 'http://qa.services.ajio.com/rilfnlwebservices/v1/deliveryType/availability'
    },
    membershipDetails: {
      href: 'http://api-internal.ajioqa.jio.com/membership/runtime'
    },
    deviceLevelCohort: {
      href: 'https://qa.services.ajio.com/service/am/runtime/cohort/getUserSegmentAndCohort/device/'
    },
    deviceLevelCohortV2: {
      href:
        'https://qa.services.ajio.com/service/am/runtime/v2/cohort/getUserSegmentAndCohort/device/'
    },
    deviceLevelCohortV3: {
      href:
        'https://qa.services.ajio.com/service/am/runtime/v3/cohort/getUserSegmentAndCohort/device/'
    },
    recommendationWidget: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/recommendation/v1/widget/config'
    },
    jioAdsSapiApi: {
      href: 'https://mercury-stg.jio.com/delivery/sapi.php'
    },
    productDeliveryTypeRush: {
      href: 'http://10.21.77.213:8080/aggregator/pdp/deliveryType'
    },
    uaasB2BUsers: {
      href: 'http://uaas-uat.ajio.com/uaas/b2b/users'
    },
    recommendationWidgetOsmos: {
      href: 'https://qa.services.ajio.com/rilfnlwebservices/recommendation/v1/page/data'
    },
    bannerAdsOsmos: {
      href: 'https://ajio-ba.o-s.io/v2/bsda/pt'
    },
    osmosClickTracker: {
      href: 'https://t.o-s.io/aclick/'
    },
    osmosImpressionTracker: {
      href: 'https://t.o-s.io/events?event_name=funnel_impression'
    }
  },
  // this requires full build
  properties: {
    version: '01.03.00',
    environment: 'SIT-118',
    siteUrl: 'https://10.21.76.118:9002',
    baseImgUrl: 'https://10.21.76.118:9002',
    // assetUrl: 'http://localhost:3000',
    assetUrl: 'https://assets-uat.ajio.ril.com',
    // assetUrl: 'http://localhost:3000',
    imageBaseUrl: 'https://assets-uat.ajio.ril.com',
    // imageBaseUrl: 'http://localhost:3000',
    parentUrl: 'https://sit.services.ajio.com',
    // parentUrl: 'http://localhost:3000',
    apiUrl: 'https://qa.services.ajio.com',
    wishlistUrl: 'http://10.21.77.105:7788',
    cartUrl: 'https://qa.services.ajio.com',
    gamificationApiUrl: 'http://10.166.181.131:8080/gamification',
    paymentURL: 'https://payment-uat.services.ajio.com',
    // paymentURL: 'http://localhost:3333',
    loginPageURL: 'https://login-uat.services.ajio.com',
    // loginPageURL: 'http://localhost:3000',
    luxeURL: 'https://sit-luxe.services.ajio.com',
    // luxeURL: 'http://localhost:3000',
    streetURL: 'https://sit-street.services.ajio.com',
    // streetURL: 'http://localhost:3000',
    fleekURL: 'https://sit-ajiogram.services.ajio.com',
    // fleekURL: 'http://localhost:3000',
    luxeGoogleUrl: 'https://uat-luxe.services.ajio.com',
    pAPI: 'https://payment-uat.services.ajio.com',
    npeBaseUrl: 'http://10.21.77.178:8080',
    cemUrl: 'https://qa.services.ajio.com/cem',
    previewCheck: false,
    gtmCode: 'T9R7HP2',
    optimizeID: 'OPT-5WNQLZ3',
    GAID: 'UA-68002030-3',
    APIErrorGAID: 'UA-68002030-3',
    appAjioText: 'AJIO Online Shopping App',
    appAjioInstallText: 'Use App for a better experience',
    androidAppBaseLink: 'android-app://com.ril.ajio/',
    iosAppBaseLink: 'ios-app://1113425372/',
    fbAppId: '530272470511330',
    googleClientId: '451315316170-qir4dv350qkc1214i1786p0tq184df0m.apps.googleusercontent.com',
    roadBlock: true,
    newsletterposition: 8,
    dataGrinchAppKey: 'app5b30bd81184dfd0962a57ab3',
    rumMOKey: '44dc1dcb26a7e73e94d36e0752e90788',
    pe: 'ON', // "OFF" for turning OFF
    timeout: 25000,
    timeoutNode: 30000,
    timeoutClient: 40000,
    dropAtStore: 'ON',
    dropAtStoreBanner: 'Available only at Trends stores in Bangalore',
    pickFromStore: 'ON',
    downloadInvoiceFlag: true,
    gpayAppticker: 'ON', // ON = hide, OFF = show
    gpayRoadBlock: 'ON', // ON = hide, OFF = show
    pickFromStoreBanner: 'Available only at Trends stores in Bangalore',
    cleverTapID: 'TEST-485-5Z9-WZ5Z',
    firebaseConfig: JSON.stringify({
    
    }),
    firebaseConfig_M: JSON.stringify({
    
    }),
    jioBannerAdsListingAdspotId: 'kuna3rfc',
    ajiogramStoreName: 'ajiogram',
    affiseApiKey: '0bdc26bc87679304f6b1e60f9ffa2e17',
    webAppVersion: '1.0.0',
    segment_api_write_key : '6ZXO0EhAQC841nn7C2ieNojaA0KUF71F',
    copilotURL: 'https://script.copilot.live/v1/copilot.min.js?tkn=cat-k0qs65mp',
    amplitude_experiment_server_key: 'server-yjmvocL95ICOPY0GXmbnnPsLhCkZbHQw',
    ajioLoyaltyServiceUrl: 'https://ajio-wallet-gateway-qa-1065083526585.asia-south1.run.app'
  }
};